import { JIKE_WEB_HOST, JIKE_WEB_MOBILE_HOST } from './request/host'

const JIKE_HASHTAG_URL_SCHEME_REGEXP = /^jike:\/\/page\.jk\/hashtag\/([a-zA-Z0-9]+)(?:\?.*)?$/

export function getSearchParams() {
	return new URL(window.location.href).searchParams
}
export function getSearchParam(key: string) {
	return getSearchParams().get(key)
}
export function isInternalLink(link: string) {
	try {
		const url = new URL(link)

		return [JIKE_WEB_MOBILE_HOST, JIKE_WEB_HOST].some((item) => item.includes(url.hostname))
	} catch (e) {
		return false
	}
}

export function getMobileHashtagURL(urlScheme: string) {
	const [, hashtagId] = urlScheme.match(JIKE_HASHTAG_URL_SCHEME_REGEXP) ?? []
	if (!hashtagId) {
		return null
	}

	return new URL(`/hashtags/${hashtagId}`, JIKE_WEB_MOBILE_HOST).href
}
